import { FieldValues, FormState } from 'react-hook-form'
import { REQUIRED_SYMBOL } from 'src/Configuration'

export const buildLabelWithRequiredSuffix = (label: string): string => {
  return `${label}${REQUIRED_SYMBOL}`
}

export const buildLabelWithRequiredPrefix = (label: string): string => {
  return `${REQUIRED_SYMBOL}${label}`
}

/**
 * Returns a new object containing only the fields that have changed based on the dirtyFields object.
 * Works with React Hook Form only
 */
export function stripUnchangedValues<T extends FieldValues>(data: Partial<T>, dirtyFields: FormState<T>['dirtyFields']): Partial<T> {
  return Object.fromEntries(
    Object.entries(dirtyFields).map(([key, value]) => {
      const dataValue = data[key as keyof T]

      if (typeof value === 'object' && dataValue) {
        return [key, stripUnchangedValues(dataValue, value as FormState<T>['dirtyFields'])]
      }

      return [key, dataValue]
    })
  )
}
